import React from "react";
import {
  Button,
  Typography,
  Grid,
  Box,
  Paper,
  Divider,
} from "@material-ui/core";
import { PictureAsPdf, Image as ImageIcon } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { updateAthleteResult } from "../../../../data-store/actions/events-actions";
import { TiempoAPasoMinxK } from "../../../../services/utils";
import EditableField from "../../../EditableField/EditableField";
import { DescargarCertificadoReg } from "./certificadoLogic";

const descargarCertificadoReg = (
  e,
  eventDetail,
  resultadoJSON,
  tipo,
  certificateConfig
) => {
  e.preventDefault();
  DescargarCertificadoReg(eventDetail, resultadoJSON, tipo, certificateConfig);
};

const AtleteData = ({ eventDetail, resultado }) => {
  const dispatch = useDispatch();
  const userID = useSelector((state) => state.atlete.userID);

  const paso = TiempoAPasoMinxK(resultado.to, resultado.mod);

  const eventConfiguration = useSelector(
    (state) => state.events.eventConfiguration
  );

  const certificateConfig =
    eventConfiguration &&
      eventConfiguration.timingConfig &&
      eventConfiguration.timingConfig.certificateConfig
      ? eventConfiguration.timingConfig.certificateConfig
      : false;

  const subclasificaciones =
    (eventConfiguration &&
      eventConfiguration.timingConfig &&
      eventConfiguration.timingConfig.subclasificaciones) ||
    {};

  resultado = { ...resultado, ...setStatus(resultado, eventConfiguration) };

  function handleChange(data) {

    const notes = resultado?.extraData?.notes || [];
    const newNote = {
      description: "Cambio de nombre a: " + data.nombre,
      date: new Date().toISOString(),
      userId: userID,
    };

    const newNotes = [...(notes || []), newNote];

    dispatch(
      updateAthleteResult("evento_" + eventDetail.iDEvento, resultado.num, {
        ...data, extraData: {
          ...(resultado?.extraData || {}),
          notes: newNotes,
        }
      })
    );
  }

  function handleChangeSubclasificacion(id, nombreSubclasif, data) {
    const nuevoValor = data["subclasificaciones/" + id];
    const notes = resultado?.extraData?.notes || [];
    const newNote = {
      description: `Cambio de subclasificación "${nombreSubclasif}" a: ${nuevoValor}`,
      date: new Date().toISOString(),
      userId: userID,
    };

    const newNotes = [...(notes || []), newNote];

    dispatch(
      updateAthleteResult("evento_" + eventDetail.iDEvento, resultado.num, {
        ...data, extraData: {
          ...(resultado?.extraData || {}),
          notes: newNotes,
        }
      })
    );
  }

  function setStatus(resultadoFunc, eventConfigurationFunc) {
    resultadoFunc.text = "";
    resultadoFunc.button = "";
    if (resultadoFunc.nombre.indexOf("*") > 0) {
      resultadoFunc.pG = 0;
      resultadoFunc.pR = 0;
      resultadoFunc.pCat = 0;
      resultadoFunc.dnfPlus = true;
    }
    if (resultadoFunc.borrado) {
      resultadoFunc.dq = true;
    }
    if (!resultadoFunc.borrado && resultadoFunc.pG === 0) {
      resultadoFunc.dnf = true;
    }
    if (
      !resultadoFunc.registroSalida &&
      !resultadoFunc.parciales &&
      resultadoFunc.pG === 0
    ) {
      resultadoFunc.dns = true;
    }
    if (resultadoFunc.dnfPlus && !resultadoFunc.dns) {
      resultadoFunc.text =
        "El atleta no finalizó el evento en el tiempo previsto para la distancia.";
      resultadoFunc.button = "DNF";
    } else if (resultadoFunc.dnf && !resultadoFunc.dns) {
      resultadoFunc.text = "El atleta no finalizó el evento.";
      resultadoFunc.button = "DNF";
    } else if (resultadoFunc.dq) {
      resultadoFunc.text =
        "El atleta fue descalificado por los jueces del evento.";
      resultadoFunc.button = "DQ";
    } else if (resultadoFunc.dns && !resultadoFunc.dq) {
      resultadoFunc.text = "El atleta no inició el evento.";
      resultadoFunc.button = "DNS";
    }
    return resultadoFunc;
  }

  return (
    <Paper style={{ padding: 16, marginBottom: 24 }} elevation={2}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={8}>
          <EditableField
            fieldObject={{
              label: "Nombres y apellidos",
              errorMessage: "Campo Requerido",
              fieldName: "nombre",
              type: "text",
              defaultValue: resultado.nombre,
              required: true,
              regex: "",
              textSize: "h6",
            }}
            onSubmit={handleChange}
          />
          <Typography variant="body2" color="textSecondary">
            {resultado.text}
          </Typography>
        </Grid>

        <Grid item xs={12} md={4}>
          <Grid container spacing={1} justify="flex-end">
            <Grid item xs={6} sm={6} md={6}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<ImageIcon />}
                fullWidth
                onClick={(e) =>
                  descargarCertificadoReg(
                    e,
                    eventDetail,
                    resultado,
                    2,
                    certificateConfig
                  )
                }
              >
                Descargar JPG
              </Button>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<PictureAsPdf />}
                fullWidth
                onClick={(e) =>
                  descargarCertificadoReg(
                    e,
                    eventDetail,
                    resultado,
                    1,
                    certificateConfig
                  )
                }
              >
                Descargar PDF
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Divider style={{ margin: "16px 0" }} />

      <Grid container spacing={2}>
        {[
          ["Número", resultado.num],
          ["Género", resultado.gen],
          ["Categoría", resultado.cat],
          ["Modalidad", resultado.mod],
        ].map(([label, value], idx) => (
          <Grid key={idx} item xs={6} md={3}>
            <Box textAlign="center">
              <Typography variant="subtitle2">{label}</Typography>
              <Typography variant="h6">{value}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Divider style={{ margin: "16px 0" }} />

      <Grid container spacing={2}>
        {[
          ["T. Oficial", resultado.toMS || resultado.to],
          ["T. Chip", resultado.tcMS || resultado.tc],
          ["Paso min/K", paso],
          ["P. General", resultado.pG],
          ["P. Rama", resultado.pR],
          ["P. Categoría", resultado.pCat],
        ].map(([label, value], idx) => (
          <Grid key={idx} item xs={6} md={2}>
            <Paper
              elevation={3}
              style={{
                backgroundColor: "#f44336",
                color: "#fff",
                padding: 12,
                textAlign: "center",
              }}
            >
              <Typography variant="subtitle2">{label}</Typography>
              <Typography variant="h6">{value}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {Object.keys(subclasificaciones).length > 0 && (
        <>
          <Divider style={{ margin: "16px 0" }} />
          <Typography variant="subtitle1" gutterBottom>
            Subclasificaciones
          </Typography>
          <Grid container spacing={2}>
            {Object.keys(subclasificaciones).map((id) => (
              <Grid key={id} item xs={12} md={4}>
                <EditableField
                  fieldObject={{
                    label: subclasificaciones[id].nombre,
                    errorMessage: "",
                    fieldName: "subclasificaciones/" + id,
                    type: "text",
                    defaultValue:
                      (resultado.subclasificaciones && resultado.subclasificaciones[id]) || "",
                    required: false,
                    regex: "",
                    textSize: "body1",
                  }}
                  onSubmit={(data) =>
                    handleChangeSubclasificacion(id, subclasificaciones[id].nombre, data)
                  }
                />
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </Paper>
  );
};

export default AtleteData;
